<template>
  <v-container fluid class="pa-0" style="height: 100%">
    <v-card flat class="rounded-0">

      <v-container class="d-flex pl-2 pr-4 py-2">
        <v-row no-gutters>
          <v-col cols="auto">
            <v-btn v-if="closable" color="close" class="mr-2" icon @click="close()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col :cols="0" :class="!closable ? 'mx-3' : 'mr-4'">
            <v-text-field v-model="listfilter" single-line dense clearable hide-details
              :label="$t('servicesystem.common_objects.commonterms.filter')" />
          </v-col>
          <v-col cols="auto" v-if="newable" class="d-flex justify-end align-center">
            <v-btn @click="createnew()" small color="primary">
              <v-icon size="17" class="mr-1">mdi-plus</v-icon>{{ $t('servicesystem.common_objects.commonterms.new') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <QScroll :height="listheight" :list="filteredList" :loading="loading" :skeletonloading="true">

        <template slot="list-item" slot-scope="{ item }">

          <v-list-item v-if="!showdetails" @click="select(item)" :class="IsActive(item) ? '' : 'deletedcolor'">
            <v-list-item-icon class="my-auto">
              <v-icon v-text="IsActive(item) ? 'mdi-account-tie' : 'mdi-account-off'"
                :color="IsActive(item) ? '' : 'disabled'" />
            </v-list-item-icon>
            <v-list-item-content class="py-0">
              <v-list-item-title v-text="item.Name" :class="IsActive(item) ? 'useThemeTextColor' : ''" />
            </v-list-item-content>
            <v-list-item-action v-if="Selected && (Selected.Id === item.Id)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-list-item-action>
          </v-list-item>

          <v-hover v-slot="{ hover }" v-else>
            <ContactTemplate :Contact="item">
              <template v-slot:action-buttons>
                <v-btn v-if="AllowChangeContact" icon @click="$emit('Edit', item)">
                  <v-icon v-show="hover">mdi-pencil</v-icon>
                </v-btn>
              </template>
            </ContactTemplate>
          </v-hover>
        </template>

        <template slot="skeleton-loader">
          <v-skeleton-loader type="list-item-avatar" class="contact">
          </v-skeleton-loader>
        </template>

      </QScroll>
    </v-card>
  </v-container>
</template>


<script>
import Vue from "vue";
import clientAPI from "@/api/ClientAPIMixin.js";
import QScroll from "@/components/Sections/Containers/QScroll.vue";
import ContactTemplate from "@/components/Preview/Customer/ContactTemplate.vue";

export default {
  name: "ContactList",
  props: {
    CustomerId: [String, Number],
    Selected: [String, Number, Object],
    closable: {
      default: true,
      type: Boolean,
    },
    showdetails: Boolean,
    listheight: {
      default: 300,
      type: Number,
    },
    disableNew: {
      type: Boolean,
      default: false,
    },
    includeInactive: Boolean,
  },
  components: {
    QScroll,
    ContactTemplate,
  },
  mixins: [clientAPI],

  data: () => ({
    list: [],
    listfilter: null,
    loading: false,
  }),

  mounted() {
    this.getContacts();
  },

  methods: {
    getContacts() {
      if (this.CustomerId) {
        this.loading = true;
        this.getCustomerContactsByCustomerId(this.CustomerId, this.includeInactive)
          .then((response) => {
            response.map((e) => {
              e.MetaString = e.DisplayName + " " + e.Email + " " + e.Mobile + " " + e.FixedPhone + " " + e.Title;
            });
            this.list = response;
          })
          .catch((response) => {
            console.error("getContacts error", response);
          })
          .finally(() => {
            this.loading = false;
          });
        /*
        if (!this.Selected) {
          this.SelectDefault();
        }
        */
      }
      /*
      for (let index = 1; index < 70; index++) {
        const element = {
          Id: index,
          Name: "Person " + index,
          IsActive: index % 5 != 0,
        };
        this.list.push(element);
      }
      */
    },

    SelectDefault() {
      this.select(this.list[0]);
    },

    close() {
      this.$emit("Close");
    },

    select(item) {
      this.$emit("Select", item);
    },

    createnew() {
      this.$emit("New");
    },

    IsActive(item) {
      return item.IsActive !== false;
    },

    updateItem(item) {
      var index = this.list.findIndex((x) => x.Id == item.Id);
      if (index < 0) {
        index = this.list.length;
      }
      Vue.set(this.list, index, item);
    },
  },

  computed: {
    filteredList() {
      if (this.listfilter) {
        return this.list.filter((v) =>
          v && v.MetaString ? v.MetaString.toUpperCase().includes(this.listfilter.toUpperCase()) : null
        );
      } else {
        return this.list;
      }
    },

    newable() {
      if (this.disableNew) return false;
      return !this.CustomerPersonsReadonly && this.checkPermission("Actions", "createCustomerContact");
    },

    AllowChangeContact() {
      return !this.CustomerPersonsReadonly && this.checkPermission("Actions", "editCustomerContact");
    },
  },

  watch: {
    CustomerId: function () {
      this.getContacts();
    },
  },
};
</script>


<style lang="scss">
.v-skeleton-loader.contact .v-skeleton-loader__list-item-avatar {
  height: 40px !important;
}

.v-skeleton-loader.contact .v-skeleton-loader__list-item-avatar .v-skeleton-loader__avatar {
  height: 25px !important;
  width: 25px !important;
}
</style>